<script>
import { isValidEmail } from '@athlisis/shared';
import { normalizeEmail } from '@utils/email';

// An empty value is never flagged; required-ness stays with the parent form.
export default {
  inheritAttrs: false,
  props: {
    value: { type: String, default: '' },
    // red border for an error the parent shows itself, like "already in use"
    invalid: { type: Boolean, default: false },
  },
  data() {
    return { focused: false, touched: false };
  },
  computed: {
    badFormat() {
      return !!this.value && !isValidEmail(this.value);
    },
    // Quiet while the address is first typed, then live once the field was left
    // (or Enter pressed). A stored bad value shows straight away.
    formatState() {
      return this.badFormat && (this.touched || !this.focused) ? false : null;
    },
  },
  methods: {
    onChange(value) {
      this.$emit('input', normalizeEmail(value));
    },
    onBlur() {
      this.focused = false;
      this.touched = true;
    },
  },
};
</script>

<template>
  <div>
    <b-form-input
        v-bind="$attrs"
        :value="value"
        :state="invalid ? false : formatState"
        type="text"
        inputmode="email"
        autocapitalize="none"
        spellcheck="false"
        @input="$emit('input', $event)"
        @change="onChange"
        @focus="focused = true"
        @blur="onBlur"
        @keydown.enter="touched = true"
    />
    <b-form-invalid-feedback v-if="formatState === false" force-show>{{ $t('errors.invalidEmail') }}</b-form-invalid-feedback>
  </div>
</template>
